import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s4};
    width: 100%;
  `,
);

export const TracingArea = styled.div(
  ({ theme }) => css`
    position: relative;
    width: 280px;
    height: 280px;
    border: 2px solid ${theme.co.neutral80};
    border-radius: ${theme.bo.medium};
    background-color: ${theme.co.neutral99};
    touch-action: none;

    @media (max-width: ${theme.sz.md}) {
      width: 240px;
      height: 240px;
    }
  `,
);

export const FeedbackMessage = styled.p<{ $isError?: boolean }>(
  ({ theme, $isError }) => css`
    ${theme.typography.paragraph.base};
    color: ${$isError ? theme.co.error40 : theme.co.success40};
    text-align: center;
    margin: 0;
  `,
);

export const RetryButton = styled.button(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    padding: ${theme.sz.s2} ${theme.sz.s4};
    border: 1px solid ${theme.co.neutral80};
    border-radius: ${theme.bo.medium};
    background-color: ${theme.co.neutral99};
    color: ${theme.co.neutral10};
    cursor: pointer;

    &:hover {
      background-color: ${theme.co.neutral90};
    }
  `,
);

export const CanvasContainer = styled.div(
  () => css`
    position: relative;
    width: 100%;
    height: 100%;
  `,
);

export const CharacterOverlay = styled.div<{ $opacity: number }>(
  ({ $opacity }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${$opacity};
    transition: opacity 0.5s ease-out;
    pointer-events: none;
    font-size: 200px;
    line-height: 1;
    user-select: none;
  `,
);

export const DrawingCanvas = styled.canvas(
  () => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: crosshair;
  `,
);
